export const IMAGE_MIME_TYPE_PREFIX = 'image/';
export const IMAGE_FORMATS_GUIDANCE_MESSAGE = 'PNG, JPG, JPEG, GIF';
export const IMAGE_FILE_EXTENSION_REGEX = /\.(png|jpg|jpeg|gif)(?:[?#].*)?$/i;

export const VIDEO_MIME_TYPE_PREFIX = 'video/';
export const VIDEO_FORMATS_GUIDANCE_MESSAGE =
  'H263, M4V, MP4, MPEG, MPEG4, WebM';
export const VIDEO_FALLBACK_NOT_SUPPORTED_MESSAGE =
  'Video is not supported in fallback messages.';
export const VIDEO_THUMBNAIL_FALLBACK_MESSAGE =
  'Video thumbnail will be displayed in fallback messages.';
export const VIDEO_FILE_EXTENSION_REGEX =
  /\.(h263|m4v|mp4|mpeg|mpeg4|webm)(?:[?#].*)?$/i;

export const THUMBNAIL_MAX_IMAGE_SIZE = {
  errorMessage: 'Thumbnail must be less than 100 KB',
  label: '100 KB',
  value: 100_000,
};

export const MMS_MAX_IMAGE_SIZE = {
  errorMessage:
    'File size must be less than 1 MB (we recommend less than 500 KB for optimal sizing & resolution)',
  label: '1 MB',
  value: 1_000_000,
};

export const RCS_CARD_MAX_MEDIA_SIZE = {
  errorMessage: 'File size must be less than 100 MB',
  guidanceMessage: 'RCS Card media may not exceed 100 MB.',
  guidanceMessageImagesOnly: 'RCS Card images may not exceed 100 MB.',
  label: '100 MB',
  value: 100_000_000,
};

export const RCS_CAROUSEL_CARD_MAX_MEDIA_SIZE = {
  errorMessage: 'File size must be less than 10 MB',
  guidanceMessage:
    'File size for each RCS Carousel Card media may not exceed 10 MB.',
  guidanceMessageImagesOnly:
    'File size for each RCS Carousel Card image may not exceed 10 MB.',
  label: '10 MB',
  value: 10_000_000,
};

export const RCS_CARD_FALLBACK_MAX_IMAGE_SIZE = {
  errorMessage:
    'RCS Image is too large for the MMS Fallback. Select a new image (<1 MB) in Fallback settings.',
  label: '1 MB',
  value: 1_000_000,
};

export const RCS_CAROUSEL_FALLBACK_MAX_IMAGE_SIZE = {
  errorMessage:
    'RCS Image in Card 1 is too large for the Fallback. Select a new image (<1 MB) in Fallback settings.',
  label: '1 MB',
  value: 1_000_000,
};

/** Total combined media size limit for entire carousel (used for validation only) */
export const RCS_CAROUSEL_TOTAL_MAX_SIZE = {
  errorMessage:
    'Total file size for all carousel card media may not exceed 100 MB',
  label: '100 MB per Carousel',
  value: 100_000_000,
};

export const MMS_COMPRESSED_IMAGE_MESSAGE = `Images may be compressed to fit file size limit.`;
export const MMS_IMAGE_CARRIER_SUPPORT_MESSAGE = `Images and GIFs (MMS) aren't supported by all carriers or countries. Plain text (SMS) without media may be sent instead.`;
export const MMS_VIDEO_NOT_SUPPORTED_MESSAGE = 'MMS only supports image files';
export const MMS_ANIMATED_GIFS_MESSAGE =
  "Animated GIFs in RCS aren't supported on iOS devices. They will display as static images.";
